(function () {
    'use strict';

    angular.module('elogbooks.user.exports').controller('ExportsController', ExportsController);

    ExportsController.$inject = [
        '$state',
        '$stateParams',
        'exportCollectionResponse',
        '$translate',
        'elbDownloadService',
        'dateTimeService'
    ];

    function ExportsController(
        $state,
        $stateParams,
        exportCollectionResponse,
        $translate,
        elbDownloadService,
        dateTimeService
    ) {
        var vm = this;

        vm.exportCollectionResponse = exportCollectionResponse;
        vm.stateParams = $stateParams;
        vm.download = elbDownloadService.download;
        vm.formatDuration = dateTimeService.formatDuration;

        const STATUS_MAP = {
            0: $translate.instant('EXPORT_STATUS_QUEUED'),
            1: $translate.instant('EXPORT_STATUS_IN_PROGRESS'),
            2: $translate.instant('EXPORT_STATUS_COMPLETED'),
            3: $translate.instant('EXPORT_STATUS_FAILED'),
            4: $translate.instant('EXPORT_STATUS_IN_PROGRESS_DELAYED')
        };

        const exportTypes = (exportCollectionResponse.exportTypes || [])
            .map(type => ({
                value: type,
                title: $translate.instant('EXPORT_TYPE_' + type.toUpperCase())
            }))
            .sort((a, b) => a.title.localeCompare(b.title));

        vm.getStatusLabel = function (statusId) {
            return STATUS_MAP[statusId] || $translate.instant('EXPORT_STATUS_UNKNOWN');
        };

        vm.criteria = {
            exportType : {
                type: 'jsonselectwidget',
                title: 'TYPE',
                multiple: false,
                value: $stateParams.exportType ? JSON.parse($stateParams.exportType) : null,
                options: {
                    response: {
                        getData: function () {
                            return {exporttypes: exportTypes };
                        },
                        getLink: function () {
                            return null;
                        },
                        count: exportTypes .length
                    },
                    link: null,
                    itemValuePath: 'value',
                    itemTitlePath: 'title',
                    responseKeyPath: 'exporttypes',
                    loadmoreEnabled: false,
                    selected: null
                }
            },
            status: {
                type: 'options',
                title: 'STATUS',
                multiple: true,
                value: $stateParams.status == null ? null : [].concat($stateParams.status).map(Number),
                options: getExportStatuses()
            },
            queuedAt: {type: 'date', title: 'QUEUED_AT', value: $stateParams.queuedAt},
            startedAt: {type: 'date', title: 'STARTED_AT', value: $stateParams.startedAt, maxDependsOn: 'endedAt'},
            endedAt: {type: 'date', title: 'ENDED_AT', value: $stateParams.endedAt, minDependsOn: 'startedAt'}
        };

        function getExportStatuses() {
            return Object.keys(STATUS_MAP).map(function(key) {
                return { value: parseInt(key, 10), title: STATUS_MAP[key] };
            });
        }

        vm.search = function (params) {
            var override = { page: 1 };
            $state.go('.', angular.extend({}, params, override), { reload: $state.current });
        };
    }
})();
